import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../supabaseClient'

export default function EmployerAuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    const checkEmployer = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) { navigate('/login'); return }

      const userId = session.user.id

      const { data: employerRecord } = await supabase
        .from('employers')
        .select('id')
        .eq('id', userId)
        .single()

      if (employerRecord) {
        navigate('/employer/dashboard')
      } else {
        const user = session.user
        await supabase.from('employers').insert({
          id: userId,
          full_name: user.user_metadata?.full_name || '',
          email: user.email
        })
        navigate('/employer/signup/company')
      }
    }
    checkEmployer()
  }, [navigate])

  return (
    <div style={{ background: '#0D1B2A', height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#F5A623', fontFamily: 'sans-serif', fontSize: '16px' }}>Setting up your employer account...</div>
    </div>
  )
}
